import type { MobileLayoutItem } from '@iheartjane/data-access';

export const MOBILE_LAYOUT_LABELS: Record<MobileLayoutItem, string> = {
  calls_to_action: 'Call-to-action',
  social_links: 'Social media',
  links: 'Links',
  image: 'Image',
  text: 'Text',
};

export const DEFAULT_MOBILE_LAYOUT: MobileLayoutItem[] = [
  'calls_to_action',
  'social_links',
  'links',
  'image',
  'text',
];
